import { IconsProps } from '@/types/shared'
import React from 'react'

const ListIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect x="3" y="4" width="18" height="2" rx="1" />
                <rect x="3" y="11" width="18" height="2" rx="1" />
                <rect x="3" y="18" width="18" height="2" rx="1" />
            </svg>
        </div>
    )
}

export default ListIcons
